import React from "react";
import PropTypes from "prop-types";
import EnergyChartWindows from "./EnergyChartWindows";
import EnergyChartScrollArrows from "./EnergyChartScrollArrows";
import EnergyChartGoToMaxEndDateLink from "./EnergyChartGoToMaxEndDateLink";

const EnergyChartHeader = props => {
  return (
    <div className="cb-c-energy-chart__header">
      <EnergyChartScrollArrows
        key="arrows"
        canGoForward={props.canGoForward}
        canGoBackward={props.canGoBackward}
        onBackwardClick={props.onBackwardClick}
        onForwardClick={props.onForwardClick}
        onDateChange={props.onDateChange}
        from={props.from}
        to={props.to}
      />

      <EnergyChartGoToMaxEndDateLink
        onClick={props.onGoToMaxEndDateClick}
        text={props.goToMaxEndDateButtonText}
      />
      <EnergyChartWindows
        key="windows"
        onChange={props.onWindowChange}
        windows={props.windows}
        selectedWindow={props.selectedWindow}
      />
    </div>
  );
};

EnergyChartHeader.propTypes = {
  onWindowChange: PropTypes.func.isRequired,
  windows: PropTypes.array.isRequired,
  selectedWindow: PropTypes.string,
  canGoForward: PropTypes.bool.isRequired,
  canGoBackward: PropTypes.bool.isRequired,
  onForwardClick: PropTypes.func,
  onBackwardClick: PropTypes.func,
  from: PropTypes.instanceOf(Date).isRequired,
  to: PropTypes.instanceOf(Date).isRequired,
  onGoToMaxEndDateClick: PropTypes.func.isRequired,
  goToMaxEndDateButtonText: PropTypes.string.isRequired
};

EnergyChartHeader.defaultProps = {
  canGoForward: true,
  canGoBackward: true
};

export default EnergyChartHeader;
